module.exports = __webpack_public_path__ + "img/footerBg.73dbf814.png";